const controls = {
  displayName: {
    elementType: 'input',
    label: "Display Name",
    elementConfig: {
      type: 'text'
    },
    value: '',
    validation: {

    },
    valid: false,
    touched: false
  },
  instagram: {
    elementType: 'input',
    label: "Instagram",
    elementConfig: {
      type: 'text'
    },
    value: '',
    validation: {

    },
    valid: false,
    touched: false
  },
  email: {
    elementType: 'input',
    label: 'Email',
    elementConfig: {
      type: 'email'
    },
    value: '',
    validation: {
      isEmail: true
    },
    valid: false,
    touched: false
  },
  biography: {
    elementType: 'textarea',
    label: "Biography",
    elementConfig: {

    },
    value: '',
    validation: {

    },
    valid: false,
    touched: false
  },
  emailConfirmationDeleting: {
    elementType: 'input',
    label: 'Confirm your deletion email address and password',
    elementConfig: {
      type: 'email',
      placeholder: 'Enter email here...'
    },
    value: '',
    validation: {
      isEmail: true
    },
    valid: false,
    touched: false
  },
  passwordConfirmationDeleting: {
    elementType: 'input',
    elementConfig: {
      type: 'password',
      placeholder: 'Enter password here...'
    },
    value: '',
    validation: {
      required: true,
      minLength: 6
    },
    valid: false,
    touched: false
  },
};

export default controls;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/InfoAndEventsTab/formConfig.js